import * as Yup from 'yup';

import { PayoutStatus } from 'types';
import { formatDate } from 'utils/date';
import { formatPrice } from 'utils/helpers';
import { Flex, DeleteDialog, ApprovalPayoutDialog } from 'components';
import { Payout, PaymentHistory, MinusPayoutTypes } from 'store/api/payout';

import { FormValues, GetAdvanceBonusExtendRender } from './types';

export const getInitialValues = (data?: Payout): FormValues => ({
  notes: data?.notes || '',
  eventId: data?.eventId || undefined,
  amount: data?.amount?.toString() || '',
  date: data?.date ? formatDate(data?.date) : '',
});

export const validationSchema = Yup.object().shape({
  date: Yup.date().required(),
  eventId: Yup.number().required(),
  amount: Yup.number().min(1).required(),
  notes: Yup.string().min(5).max(200).required(),
});

export const transformPaymentHistoryData = (data?: PaymentHistory[]) => {
  const result = [];
  const dateMap: Record<string, any> = {};

  data?.forEach((entry) => {
    entry?.items?.forEach((item) => {
      const date = formatDate(entry.date);
      const key = item.eventId!;
      const isMinusType = MinusPayoutTypes.includes(item.type);
      if (dateMap[key]) {
        dateMap[key].value = isMinusType
          ? dateMap[key].value - +item.amount
          : dateMap[key].value + +item.amount;
      } else {
        dateMap[key] = {
          date,
          label: item?.event?.name,
          eventName: item?.event?.name,
          id: Object.keys(dateMap).length + 1,
          value: isMinusType ? -Number(item.amount) : Number(item.amount),
        };
      }
    });
  });

  for (const key in dateMap) {
    result.push(dateMap[key]);
  }

  return result;
};

export const getCommonListProps = (data?: any[]) => ({
  hasMinHeight: false,
  maxHeight: data?.length ? 350 : undefined,
});

export const advanceBonusCellsMobile = [
  { row: '2/3', col: '1/2' },
  { row: '1/2', col: '1/3' },
  { row: '2/3', col: '2/3' },
  { row: '3/4', col: '1/3' },
  { row: '4/5', col: '1/3' },
  { row: '5/6', col: '1/3' },
];

export const getAdvanceBonusExtendRender = ({
  type,
  mobile,
  remove,
  isCompanyOwner,
}: GetAdvanceBonusExtendRender) =>
  isCompanyOwner
    ? (value: Payout) => [
        <Flex
          gap={8}
          fullWidth={mobile}
          justifyContent={mobile ? 'space-between' : 'flex-end'}
        >
          {value.status === PayoutStatus.Pending && (
            <ApprovalPayoutDialog type={type} data={value} />
          )}

          <DeleteDialog
            id={value.id}
            action={remove}
            title={`Delete ${type.toLowerCase()}`}
            name={`${type.toLowerCase()} with ${formatPrice(value.amount)}`}
          />
        </Flex>,
      ]
    : undefined;
